/**
 * Комментарии задачи.
 *
 * Тело хранится в markdown — тем же, что описание и страницы базы знаний.
 * Упомянутых сервис из текста не выковыривает: их присылает редактор, который
 * знает, кого выбрали из подсказки, и по этому списку уходят уведомления.
 */
import { issueApi } from '@/api'

import type { V1Comment } from '@/api/clients/tracker-issue'

/** Сколько комментариев берём за раз: в макете лента, а не страницы */
export const COMMENTS_PER_PAGE = 20

export interface Comment {
  id: string
  authorId: string
  authorName: string
  bodyMd: string
  createdAt: string
  updatedAt: string
}

const toComment = (comment: V1Comment): Comment => ({
  id: comment.id ?? '',
  authorId: comment.authorId ?? '',
  authorName: comment.authorName ?? '',
  bodyMd: comment.bodyMd ?? '',
  createdAt: comment.createdAt ?? '',
  updatedAt: comment.updatedAt ?? '',
})

export interface CommentPage {
  comments: Comment[]
  total: number
}

export const listComments = async (issueId: string, page = 1): Promise<CommentPage> => {
  const { data } = await issueApi.issueServiceListComments(
    issueId,
    String(page),
    String(COMMENTS_PER_PAGE),
  )

  return {
    comments: (data.comments ?? []).map(toComment),
    total: Number(data.pageInfo?.total ?? 0),
  }
}

export const createComment = async (
  issueId: string,
  bodyMd: string,
  mentionedUserIds: string[],
): Promise<Comment | null> => {
  const { data } = await issueApi.issueServiceCreateComment(issueId, { bodyMd, mentionedUserIds })

  return data.comment ? toComment(data.comment) : null
}

export const updateComment = async (
  id: string,
  bodyMd: string,
  mentionedUserIds: string[],
): Promise<Comment | null> => {
  const { data } = await issueApi.issueServiceUpdateComment(id, { bodyMd, mentionedUserIds })

  return data.comment ? toComment(data.comment) : null
}

export const deleteComment = async (id: string): Promise<void> => {
  await issueApi.issueServiceDeleteComment(id)
}
